import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import Flex from '@decisiv/ui-components/lib/components/Flex';

const pacificOcean = toColorString(color.interaction.pacificOcean);

const IntegrationContainerWrapper = styled(Flex)`
  flex-shrink: 0;
  width: 400px;
  word-break: break-word;
  background-color: ${toColorString(color.base.snowWhite)};
  box-sizing: border-box;
  border: 1px solid
    ${({ selected }) => (selected ? pacificOcean : 'var(--if-border)')};
  border-radius: 4px;
`;

export { IntegrationContainerWrapper };
